import type { TourDefinition } from "./types";

export const PUBLICATION_DEMO_BUILD_STEP_INDEX = 7;

export const TOURS: TourDefinition[] = [
  {
    id: "creator-dashboard",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.creatorDashboard.title",
    descriptionKey: "onboarding.tours.creatorDashboard.description",
    startRoute: "/",
    steps: [
      {
        anchor: "dashboard-new-course",
        titleKey: "onboarding.tours.creatorDashboard.steps.dashboardNewCourse.title",
        bodyKey: "onboarding.tours.creatorDashboard.steps.dashboardNewCourse.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "course-wizard-name",
        titleKey: "onboarding.tours.creatorDashboard.steps.wizardName.title",
        bodyKey: "onboarding.tours.creatorDashboard.steps.wizardName.body",
        placement: "right",
        hint: true,
      },
      {
        anchor: "course-wizard-thumbnail",
        titleKey: "onboarding.tours.creatorDashboard.steps.wizardThumbnail.title",
        bodyKey: "onboarding.tours.creatorDashboard.steps.wizardThumbnail.body",
        whileOpen: {
          anchor: "media-gallery-confirm",
          titleKey: "onboarding.tours.creatorDashboard.steps.wizardGallery.title",
          bodyKey: "onboarding.tours.creatorDashboard.steps.wizardGallery.body",
          placement: "top-end",
        },
        placement: "right",
        hint: true,
      },
      {
        anchor: "course-wizard-menu-media",
        titleKey: "onboarding.tours.creatorDashboard.steps.wizardMenuMedia.title",
        bodyKey: "onboarding.tours.creatorDashboard.steps.wizardMenuMedia.body",
        whileOpen: {
          anchor: "media-gallery-confirm",
          titleKey: "onboarding.tours.creatorDashboard.steps.wizardGallery.title",
          bodyKey: "onboarding.tours.creatorDashboard.steps.wizardGallery.body",
          placement: "top-end",
        },
        placement: "right",
        hint: true,
      },
      {
        anchor: "course-wizard-theme",
        titleKey: "onboarding.tours.creatorDashboard.steps.wizardTheme.title",
        bodyKey: "onboarding.tours.creatorDashboard.steps.wizardTheme.body",
        placement: "top-end",
        hint: true,
      },
      {
        anchor: "course-wizard-access",
        titleKey: "onboarding.tours.creatorDashboard.steps.wizardAccess.title",
        bodyKey: "onboarding.tours.creatorDashboard.steps.wizardAccess.body",
        placement: "left",
        hint: true,
        wide: true,
      },
      {
        kind: "await",
        untilChecklistItem: "create-course",
        allowedRoutes: ["/", "/courses/new"],
      },
      {
        anchor: "course-new-module",
        titleKey: "onboarding.tours.creatorDashboard.steps.courseCreated.title",
        bodyKey: "onboarding.tours.creatorDashboard.steps.courseCreated.body",
        handoffTourId: "course-modules",
      },
    ],
  },
  {
    id: "open-course",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.openCourse.title",
    descriptionKey: "onboarding.tours.openCourse.description",
    startRoute: "/courses",
    hidden: true,
    steps: [
      {
        anchor: "course-card-open",
        titleKey: "onboarding.tours.openCourse.steps.courseCardOpen.title",
        bodyKey: "onboarding.tours.openCourse.steps.courseCardOpen.body",
        advanceOn: "targetClick",
        hint: true,
      },
    ],
  },
  {
    id: "open-module",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.openModule.title",
    descriptionKey: "onboarding.tours.openModule.description",
    startRoute: "/courses",
    hidden: true,
    steps: [
      {
        anchor: "course-card-open",
        titleKey: "onboarding.tours.openModule.steps.courseCardOpen.title",
        bodyKey: "onboarding.tours.openModule.steps.courseCardOpen.body",
        advanceOn: "targetClick",
        hint: true,
      },
      {
        anchor: "module-card-open",
        titleKey: "onboarding.tours.openModule.steps.moduleCardOpen.title",
        bodyKey: "onboarding.tours.openModule.steps.moduleCardOpen.body",
        advanceOn: "targetClick",
        hint: true,
      },
    ],
  },
  {
    id: "course-modules",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.courseModules.title",
    descriptionKey: "onboarding.tours.courseModules.description",
    startRoute: null,
    locationHintKey: "onboarding.tours.courseModules.locationHint",
    bridgeTourId: "open-course",
    steps: [
      {
        anchor: "course-new-module",
        titleKey: "onboarding.tours.courseModules.steps.courseNewModule.title",
        bodyKey: "onboarding.tours.courseModules.steps.courseNewModule.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "module-wizard-start",
        titleKey: "onboarding.tours.courseModules.steps.wizardStart.title",
        bodyKey: "onboarding.tours.courseModules.steps.wizardStart.body",
        placement: "right",
        hint: true,
        wizardRoutes: ["/courses/:id/new/:templateId"],
        branchOn: { anchor: "module-wizard-ai", tourId: "scenaria-create" },
      },
      {
        anchor: "module-wizard-overview",
        titleKey: "onboarding.tours.courseModules.steps.wizardOverview.title",
        bodyKey: "onboarding.tours.courseModules.steps.wizardOverview.body",
        placement: "right",
        hint: true,
        wizardRoutes: ["/courses/:id/new"],
      },
      {
        anchor: "module-wizard-name",
        titleKey: "onboarding.tours.courseModules.steps.wizardName.title",
        bodyKey: "onboarding.tours.courseModules.steps.wizardName.body",
        placement: "right",
        hint: true,
      },
      {
        anchor: "module-wizard-languages",
        titleKey: "onboarding.tours.courseModules.steps.wizardLanguages.title",
        bodyKey: "onboarding.tours.courseModules.steps.wizardLanguages.body",
        placement: "left",
        hint: true,
      },
      {
        anchor: "module-wizard-thumbnail",
        titleKey: "onboarding.tours.courseModules.steps.wizardThumbnail.title",
        bodyKey: "onboarding.tours.courseModules.steps.wizardThumbnail.body",
        whileOpen: {
          anchor: "media-gallery-confirm",
          titleKey: "onboarding.tours.courseModules.steps.wizardGallery.title",
          bodyKey: "onboarding.tours.courseModules.steps.wizardGallery.body",
          placement: "top-end",
        },
        placement: "right",
        hint: true,
      },
      {
        kind: "await",
        untilChecklistItem: "create-module",
        allowedRoutes: ["/courses/:id/new", "/courses/:id/new/:templateId"],
      },
      {
        anchor: "project-create-scene",
        titleKey: "onboarding.tours.courseModules.steps.moduleCreated.title",
        bodyKey: "onboarding.tours.courseModules.steps.moduleCreated.body",
        placement: "right",
        handoffTourId: "graph-flow-intro",
      },
    ],
  },
  {
    id: "scenaria-assistant",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.scenariaAssistant.title",
    descriptionKey: "onboarding.tours.scenariaAssistant.description",
    startRoute: null,
    locationHintKey: "onboarding.tours.scenariaAssistant.locationHint",
    steps: [
      {
        anchor: "scenaria-field-focus",
        titleKey: "onboarding.tours.scenariaAssistant.steps.scenariaFieldFocus.title",
        bodyKey: "onboarding.tours.scenariaAssistant.steps.scenariaFieldFocus.body",
      },
      {
        anchor: "scenaria-composer",
        titleKey: "onboarding.tours.scenariaAssistant.steps.scenariaComposer.title",
        bodyKey: "onboarding.tours.scenariaAssistant.steps.scenariaComposer.body",
      },
      {
        anchor: "scenaria-proposal",
        titleKey: "onboarding.tours.scenariaAssistant.steps.scenariaProposal.title",
        bodyKey: "onboarding.tours.scenariaAssistant.steps.scenariaProposal.body",
      },
    ],
  },
  {
    id: "team-management",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.teamManagement.title",
    descriptionKey: "onboarding.tours.teamManagement.description",
    startRoute: null,
    locationHintKey: "onboarding.tours.teamManagement.locationHint",
    bridgeTourId: "open-course",
    steps: [
      {
        anchor: "tab-team",
        titleKey: "onboarding.tours.teamManagement.steps.courseTeamTab.title",
        bodyKey: "onboarding.tours.teamManagement.steps.courseTeamTab.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "course-team-add-existing",
        titleKey: "onboarding.tours.teamManagement.steps.addExisting.title",
        bodyKey: "onboarding.tours.teamManagement.steps.addExisting.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "add-team-picker",
        titleKey: "onboarding.tours.teamManagement.steps.pickMembers.title",
        bodyKey: "onboarding.tours.teamManagement.steps.pickMembers.body",
        audiences: ["creator"],
        placement: "right",
        hint: true,
      },
      {
        anchor: "add-team-picker",
        titleKey: "onboarding.tours.teamManagement.steps.pickMembersAdmin.title",
        bodyKey: "onboarding.tours.teamManagement.steps.pickMembersAdmin.body",
        audiences: ["admin"],
        placement: "right",
        hint: true,
      },
      {
        anchor: "course-team-list",
        titleKey: "onboarding.tours.teamManagement.steps.courseTeamList.title",
        bodyKey: "onboarding.tours.teamManagement.steps.courseTeamList.body",
      },
      {
        anchor: "tab-learners",
        titleKey: "onboarding.tours.teamManagement.steps.learnersTab.title",
        bodyKey: "onboarding.tours.teamManagement.steps.learnersTab.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "learners-add",
        titleKey: "onboarding.tours.teamManagement.steps.learnersAdd.title",
        bodyKey: "onboarding.tours.teamManagement.steps.learnersAdd.body",
        placement: "left",
        advanceOn: "targetClick",
      },
      {
        anchor: "user-form-submit",
        titleKey: "onboarding.tours.teamManagement.steps.learnerForm.title",
        bodyKey: "onboarding.tours.teamManagement.steps.learnerForm.body",
        placement: "top-end",
        hint: true,
      },
      {
        kind: "await",
        untilSignal: "enduser-invited",
        allowedRoutes: ["/courses/:id/learners/new", "/courses/:id/learners"],
      },
      {
        anchor: "sidebar-learners",
        titleKey: "onboarding.tours.teamManagement.steps.learnersEverywhere.title",
        bodyKey: "onboarding.tours.teamManagement.steps.learnersEverywhere.body",
        placement: "right",
      },
    ],
  },
  {
    id: "admin-team",
    audiences: ["admin"],
    titleKey: "onboarding.tours.adminTeam.title",
    descriptionKey: "onboarding.tours.adminTeam.description",
    startRoute: "/",
    steps: [
      {
        anchor: "sidebar-team",
        titleKey: "onboarding.tours.adminTeam.steps.sidebarTeam.title",
        bodyKey: "onboarding.tours.adminTeam.steps.sidebarTeam.body",
        placement: "right",
        advanceOn: "targetClick",
      },
      {
        anchor: "team-invite",
        titleKey: "onboarding.tours.adminTeam.steps.teamInvite.title",
        bodyKey: "onboarding.tours.adminTeam.steps.teamInvite.body",
      },
      {
        anchor: "team-list",
        titleKey: "onboarding.tours.adminTeam.steps.teamList.title",
        bodyKey: "onboarding.tours.adminTeam.steps.teamList.body",
        placement: "top",
      },
      {
        anchor: "sidebar-profile",
        titleKey: "onboarding.tours.adminTeam.steps.sidebarProfile.title",
        bodyKey: "onboarding.tours.adminTeam.steps.sidebarProfile.body",
        placement: "right",
        advanceOn: "targetClick",
      },
      {
        anchor: "tab-organization",
        titleKey: "onboarding.tours.adminTeam.steps.organizationTab.title",
        bodyKey: "onboarding.tours.adminTeam.steps.organizationTab.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "org-ai-context",
        titleKey: "onboarding.tours.adminTeam.steps.aiContext.title",
        bodyKey: "onboarding.tours.adminTeam.steps.aiContext.body",
        placement: "top",
        wide: true,
      },
    ],
  },
  {
    id: "scenaria-create",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.scenariaCreate.title",
    descriptionKey: "onboarding.tours.scenariaCreate.description",
    startRoute: null,
    locationHintKey: "onboarding.tours.scenariaCreate.locationHint",
    steps: [
      {
        anchor: "scenaria-workbench-composer",
        titleKey: "onboarding.tours.scenariaCreate.steps.describe.title",
        bodyKey: "onboarding.tours.scenariaCreate.steps.describe.body",
        placement: "top",
        hint: true,
        wide: true,
        advanceOn: "signal",
        signal: "scenaria-message-sent",
      },
      {
        anchor: "scenaria-workbench-attachments",
        titleKey: "onboarding.tours.scenariaCreate.steps.attachments.title",
        bodyKey: "onboarding.tours.scenariaCreate.steps.attachments.body",
        placement: "top-start",
      },
      {
        anchor: "scenaria-workbench-agents",
        titleKey: "onboarding.tours.scenariaCreate.steps.knowledgeBases.title",
        bodyKey: "onboarding.tours.scenariaCreate.steps.knowledgeBases.body",
        placement: "left",
      },
      {
        anchor: "scenaria-workbench-skip-intake",
        titleKey: "onboarding.tours.scenariaCreate.steps.answerQuestions.title",
        bodyKey: "onboarding.tours.scenariaCreate.steps.answerQuestions.body",
        placement: "right",
        hint: true,
      },
      {
        anchor: "scenaria-workbench-plan-card",
        titleKey: "onboarding.tours.scenariaCreate.steps.plan.title",
        bodyKey: "onboarding.tours.scenariaCreate.steps.plan.body",
        placement: "right",
        hint: true,
      },
      {
        anchor: "scenaria-workbench-generate",
        titleKey: "onboarding.tours.scenariaCreate.steps.generate.title",
        bodyKey: "onboarding.tours.scenariaCreate.steps.generate.body",
        placement: "right",
        hint: true,
        advanceOn: "signal",
        signal: "scenaria-generation-started",
      },
      {
        kind: "await",
        untilChecklistItem: "create-module",
        allowedRoutes: ["/chat/scenario-helper", "/courses/:id/new", "/courses/:id/list"],
      },
      {
        anchor: "module-card-latest",
        titleKey: "onboarding.tours.scenariaCreate.steps.moduleCreated.title",
        bodyKey: "onboarding.tours.scenariaCreate.steps.moduleCreated.body",
        placement: "bottom",
        advanceOn: "targetClick",
      },
    ],
  },
  {
    id: "publication",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.publication.title",
    descriptionKey: "onboarding.tours.publication.description",
    startRoute: null,
    locationHintKey: "onboarding.tours.publication.locationHint",
    bridgeTourId: "open-course",
    presenceAnchor: "tab-team",
    steps: [
      {
        anchor: "tab-publish",
        titleKey: "onboarding.tours.publication.steps.tabPublish.title",
        bodyKey: "onboarding.tours.publication.steps.tabPublish.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "publish-new",
        titleKey: "onboarding.tours.publication.steps.newPublication.title",
        bodyKey: "onboarding.tours.publication.steps.newPublication.body",
        placement: "left",
        advanceOn: "targetClick",
      },
      {
        anchor: "publish-choice",
        titleKey: "onboarding.tours.publication.steps.choice.title",
        bodyKey: "onboarding.tours.publication.steps.choice.body",
        placement: "top",
        hint: true,
        wide: true,
        wizardRoutes: ["/courses/:id/publish/new/version", "/courses/:id/publish/new/platforms"],
      },
      {
        anchor: "publish-select-modules",
        titleKey: "onboarding.tours.publication.steps.selectModules.title",
        bodyKey: "onboarding.tours.publication.steps.selectModules.body",
        placement: "top-end",
        hint: true,
        wide: true,
      },
      {
        anchor: "publish-select-platforms",
        titleKey: "onboarding.tours.publication.steps.selectPlatforms.title",
        bodyKey: "onboarding.tours.publication.steps.selectPlatforms.body",
        placement: "left",
        hint: true,
      },
      {
        anchor: "publish-confirm",
        titleKey: "onboarding.tours.publication.steps.confirm.title",
        bodyKey: "onboarding.tours.publication.steps.confirm.body",
        placement: "top-end",
        hint: true,
        wide: true,
      },
      {
        kind: "await",
        untilChecklistItem: "request-publication",
        allowedRoutes: [
          "/courses/:id/publish/new",
          "/courses/:id/publish/new/version",
          "/courses/:id/publish/new/platforms",
          "/courses/:id/publish",
        ],
      },
      {
        anchor: "publish-new",
        titleKey: "onboarding.tours.publication.steps.requestSent.title",
        bodyKey: "onboarding.tours.publication.steps.requestSent.body",
        placement: "bottom",
        wide: true,
      },
      {
        anchor: "publish-builds-published",
        titleKey: "onboarding.tours.publication.steps.publishedTable.title",
        bodyKey: "onboarding.tours.publication.steps.publishedTable.body",
        placement: "top",
        wide: true,
      },
      {
        anchor: "publish-build-share",
        titleKey: "onboarding.tours.publication.steps.shareLink.title",
        bodyKey: "onboarding.tours.publication.steps.shareLink.body",
        placement: "left",
      },
      {
        anchor: "publish-build-install",
        titleKey: "onboarding.tours.publication.steps.installOnDevice.title",
        bodyKey: "onboarding.tours.publication.steps.installOnDevice.body",
        placement: "left",
      },
      {
        anchor: "sidebar-installations",
        titleKey: "onboarding.tours.publication.steps.installationsPage.title",
        bodyKey: "onboarding.tours.publication.steps.installationsPage.body",
        placement: "right",
        advanceOn: "targetClick",
      },
    ],
  },
  {
    id: "enduser-stats",
    audiences: ["enduser"],
    titleKey: "onboarding.tours.enduserStats.title",
    descriptionKey: "onboarding.tours.enduserStats.description",
    startRoute: "/stats",
    steps: [
      {
        anchor: "stats-overview",
        titleKey: "onboarding.tours.enduserStats.steps.statsOverview.title",
        bodyKey: "onboarding.tours.enduserStats.steps.statsOverview.body",
      },
      {
        anchor: "stats-tab-parcours",
        titleKey: "onboarding.tours.enduserStats.steps.statsTabParcours.title",
        bodyKey: "onboarding.tours.enduserStats.steps.statsTabParcours.body",
      },
      {
        anchor: "stats-tab-comparateur",
        titleKey: "onboarding.tours.enduserStats.steps.statsTabComparateur.title",
        bodyKey: "onboarding.tours.enduserStats.steps.statsTabComparateur.body",
      },
      {
        anchor: "sidebar-installations",
        titleKey: "onboarding.tours.enduserStats.steps.sidebarInstallations.title",
        bodyKey: "onboarding.tours.enduserStats.steps.sidebarInstallations.body",
      },
    ],
  },
  {
    id: "graph-flow-intro",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.graphFlowIntro.title",
    descriptionKey: "onboarding.tours.graphFlowIntro.description",
    startRoute: null,
    locationHintKey: "onboarding.tours.graphFlowIntro.locationHint",
    bridgeTourId: "open-module",
    steps: [
      {
        anchor: "graph-palette-scene",
        titleKey: "onboarding.tours.graphFlowIntro.steps.addScene.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.addScene.body",
        placement: "right",
        hint: true,
      },
      {
        kind: "await",
        untilSignal: "graph-scene-created",
        allowedRoutes: ["/courses/:id/list/:projectId/graph"],
      },
      {
        anchor: "graph-relink-source",
        titleKey: "onboarding.tours.graphFlowIntro.steps.relinkScene.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.relinkScene.body",
        placement: "right",
        wide: true,
        hint: true,
      },
      {
        anchor: "graph-scene-card-latest",
        titleKey: "onboarding.tours.graphFlowIntro.steps.firstScene.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.firstScene.body",
      },
      {
        anchor: "graph-palette-interaction",
        titleKey: "onboarding.tours.graphFlowIntro.steps.addInteraction.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.addInteraction.body",
        placement: "right",
        hint: true,
      },
      {
        kind: "await",
        untilChecklistItem: "customize-module",
        allowedRoutes: ["/courses/:id/list/:projectId/graph"],
      },
      {
        anchor: "graph-scene-card-latest",
        titleKey: "onboarding.tours.graphFlowIntro.steps.interactions.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.interactions.body",
      },
      {
        anchor: "graph-topbar",
        titleKey: "onboarding.tours.graphFlowIntro.steps.topToolbar.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.topToolbar.body",
        placement: "bottom",
        wide: true,
      },
      {
        anchor: "project-soundtrack",
        titleKey: "onboarding.tours.graphFlowIntro.steps.soundtrack.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.soundtrack.body",
        placement: "right",
      },
      {
        anchor: "graph-issues",
        titleKey: "onboarding.tours.graphFlowIntro.steps.graphIssues.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.graphIssues.body",
        placement: "bottom",
      },
      {
        anchor: "graph-scene-card-latest",
        titleKey: "onboarding.tours.graphFlowIntro.steps.openScene.title",
        bodyKey: "onboarding.tours.graphFlowIntro.steps.openScene.body",
        hint: true,
        branchOn: { anchor: "interior-entry-node", tourId: "scene-interior-intro" },
      },
    ],
  },
  {
    id: "scene-interior-intro",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.sceneInteriorIntro.title",
    descriptionKey: "onboarding.tours.sceneInteriorIntro.description",
    startRoute: null,
    locationHintKey: "onboarding.tours.sceneInteriorIntro.locationHint",
    bridgeTourId: "open-module",
    presenceAnchor: "graph-palette-scene",
    autoStartAnchor: "interior-entry-node",
    scope: { anchor: "interior-breadcrumb", entryStep: 0 },
    steps: [
      {
        anchor: "graph-interior-enter",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.enterInterior.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.enterInterior.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "interior-entry-node",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.entryNode.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.entryNode.body",
        placement: "bottom",
      },
      {
        anchor: "interior-palette",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.addInteractionInside.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.addInteractionInside.body",
        placement: "right",
        hint: true,
      },
      {
        kind: "await",
        untilSignal: "graph-interaction-created",
        allowedRoutes: ["/courses/:id/list/:projectId/graph"],
      },
      {
        anchor: "interior-link-filters",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.linkFilters.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.linkFilters.body",
        placement: "bottom",
      },
      {
        anchor: "interior-toolbar",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.interiorToolbar.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.interiorToolbar.body",
        placement: "bottom",
        wide: true,
      },
      {
        anchor: "interior-dormant-zone",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.dormantZone.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.dormantZone.body",
        placement: "top",
      },
      {
        anchor: "interior-timeline",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.videoTimeline.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.videoTimeline.body",
        placement: "right",
      },
      {
        anchor: "tab-preview",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.preview.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.preview.body",
        placement: "bottom",
        advanceOn: "targetClick",
      },
      {
        anchor: "interior-breadcrumb",
        titleKey: "onboarding.tours.sceneInteriorIntro.steps.exitInterior.title",
        bodyKey: "onboarding.tours.sceneInteriorIntro.steps.exitInterior.body",
        placement: "bottom",
      },
    ],
  },
  {
    id: "creator-stats",
    audiences: ["creator", "admin"],
    titleKey: "onboarding.tours.creatorStats.title",
    descriptionKey: "onboarding.tours.creatorStats.description",
    startRoute: "/statistics",
    locationHintKey: "onboarding.tours.creatorStats.locationHint",
    steps: [
      {
        anchor: "stats-global-kpis",
        titleKey: "onboarding.tours.creatorStats.steps.kpis.title",
        bodyKey: "onboarding.tours.creatorStats.steps.kpis.body",
        placement: "bottom",
        wide: true,
      },
      {
        anchor: "stats-global-charts",
        titleKey: "onboarding.tours.creatorStats.steps.charts.title",
        bodyKey: "onboarding.tours.creatorStats.steps.charts.body",
        placement: "top",
      },
      {
        anchor: "stats-tab-parcours",
        titleKey: "onboarding.tours.creatorStats.steps.parcoursTab.title",
        bodyKey: "onboarding.tours.creatorStats.steps.parcoursTab.body",
        advanceOn: "targetClick",
      },
      {
        anchor: "stats-parcours-table",
        titleKey: "onboarding.tours.creatorStats.steps.parcoursList.title",
        bodyKey: "onboarding.tours.creatorStats.steps.parcoursList.body",
        placement: "bottom",
        advanceOn: "targetClick",
      },
      {
        anchor: "demo-data-banner",
        titleKey: "onboarding.tours.creatorStats.steps.demoData.title",
        bodyKey: "onboarding.tours.creatorStats.steps.demoData.body",
        placement: "bottom",
        wide: true,
      },
      {
        anchor: "stats-parcours-modules",
        titleKey: "onboarding.tours.creatorStats.steps.parcoursModules.title",
        bodyKey: "onboarding.tours.creatorStats.steps.parcoursModules.body",
        placement: "top",
        advanceOn: "targetClick",
      },
      {
        anchor: "stats-module-kpis",
        titleKey: "onboarding.tours.creatorStats.steps.moduleKpis.title",
        bodyKey: "onboarding.tours.creatorStats.steps.moduleKpis.body",
        placement: "bottom",
        wide: true,
      },
      {
        anchor: "stats-module-graph",
        titleKey: "onboarding.tours.creatorStats.steps.moduleGraph.title",
        bodyKey: "onboarding.tours.creatorStats.steps.moduleGraph.body",
        placement: "top",
        wide: true,
      },
      {
        anchor: "stats-module-tab-sessions",
        titleKey: "onboarding.tours.creatorStats.steps.moduleSessionsTab.title",
        bodyKey: "onboarding.tours.creatorStats.steps.moduleSessionsTab.body",
        placement: "bottom",
        advanceOn: "targetClick",
      },
      {
        anchor: "stats-module-sessions",
        titleKey: "onboarding.tours.creatorStats.steps.moduleSessions.title",
        bodyKey: "onboarding.tours.creatorStats.steps.moduleSessions.body",
        placement: "top",
        wide: true,
      },
      {
        anchor: "stats-tab-classement",
        titleKey: "onboarding.tours.creatorStats.steps.classementTab.title",
        bodyKey: "onboarding.tours.creatorStats.steps.classementTab.body",
        placement: "bottom",
        advanceOn: "targetClick",
      },
      {
        anchor: "stats-classement-controls",
        titleKey: "onboarding.tours.creatorStats.steps.classement.title",
        bodyKey: "onboarding.tours.creatorStats.steps.classement.body",
        placement: "bottom",
        wide: true,
      },
      {
        anchor: "stats-tab-comparateur",
        titleKey: "onboarding.tours.creatorStats.steps.comparateurTab.title",
        bodyKey: "onboarding.tours.creatorStats.steps.comparateurTab.body",
        placement: "bottom",
        advanceOn: "targetClick",
      },
      {
        anchor: "stats-comparateur-picker",
        titleKey: "onboarding.tours.creatorStats.steps.comparateur.title",
        bodyKey: "onboarding.tours.creatorStats.steps.comparateur.body",
        placement: "right",
      },
      {
        anchor: "stats-tab-reports",
        titleKey: "onboarding.tours.creatorStats.steps.reportsTab.title",
        bodyKey: "onboarding.tours.creatorStats.steps.reportsTab.body",
        placement: "bottom",
        advanceOn: "targetClick",
      },
      {
        anchor: "stats-reports-new",
        titleKey: "onboarding.tours.creatorStats.steps.reportsNew.title",
        bodyKey: "onboarding.tours.creatorStats.steps.reportsNew.body",
        placement: "left",
      },
    ],
  },
];
